import {match, Pattern} from 'ts-pattern';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CustomerDiscriminator} from '@dms/api/customer';

import {Nullish} from 'shared/web';

import {SaneCustomerType} from '../types';

/**
 * Derives the {@link SaneCustomerType} for a selection made in the customer search.
 *
 * A present `contactId` always means a specific contact person was picked, which maps
 * to `contactPerson` regardless of the customer's discriminator. Without a contact the
 * selection is at the customer level and maps to the discriminator itself.
 */
export const getSaneCustomerType = (
  discriminator: CustomerDiscriminator,
  contactId: string | Nullish
): SaneCustomerType =>
  match<[CustomerDiscriminator, boolean], SaneCustomerType>([
    discriminator,
    isNotNilOrEmpty(contactId),
  ])
    .with([Pattern.any, true], () => 'contactPerson')
    .with(['NATURAL_PERSON', false], () => 'physicalPerson')
    .with(['BUSINESS', false], () => 'business')
    .exhaustive();
